import { Link } from "react-router-dom";
import { BOM } from "../../../../services/definedMethod";

/*!*******************************************************************************!
  !***FX-TRANSACTION PURCHASE  API CONFIG                                                       ***!
  \*******************************************************************************/
export const purchaseTransactionApi = {
  // Purchase Transaction
  purchaseTransaction: BOM.baseUrl("fxtransactions"),
  newPurchaseTransaction: BOM.baseUrl("fxtransactions/buy"),
  GetCurrencies: BOM.baseUrl("currencies"),
  GetLocalCurrencies: BOM.baseUrl("fxtransactions/localcurrency"),
  GetByAccountNo: BOM.baseUrl("savingsaccounts/findbyaccountno"),
  GetFxCharges: BOM.baseUrl("savingsproducts"),
  convertAmount: BOM.baseUrl("fxtransactions"),
};

/*!*******************************************************************************!
  !*** FX-TRANSACTION PURCHASE  LABEL CONFIG                                                       ***!
  \*******************************************************************************/
export const purchaseTransactionLabel = {
  managePurchaseTransaction: "Manage FX Purchase Transaction",
  newPurchaseTransaction: "New FX Purchase Transaction",
  purchaseTransactionDetail: "FX Purchase Transaction  Detail",
  transactionDate: "Transaction Date",
  amountACY: "Amount ACY",
  accountNo: "Account No",
  transactionType: "Transaction Type",
  accountName: "Account Name",
  accountCurrency: "Account Currency",
  transactionCCY: "Transaction CCY",
  amountLCY: "Amount LCY",
  amountTCY: "Amount TCY",
  charge: "Charge",
  currencyRate: "Currency Rate",
  chargeId: "Charge Id",
  currency: "Currency",
  purchaseTransactionSetup: "Purchase Transaction Setup",
  newPurchaseTransactionMsg: "FX Purchase Transaction was successfully created",
  editPurchaseTransactionMsg: "FX Purchase Transaction was successfully edited",
  generalInfo: "General Information",
};

/*!*******************************************************************************!
    !*** FX-TRANSACTION PURCHASE STATIC CONFIG                                                      ***!
    \*******************************************************************************/
export const purchaseTransactionStatic = {
  managePurchaseTransactionItems: [
    { title: purchaseTransactionLabel.managePurchaseTransaction },
  ],
  detailPurchaseTransactionItems: [
    {
      title: (
        <Link to="/tlo1201">
          {purchaseTransactionLabel.managePurchaseTransaction}
        </Link>
      ),
    },
    { title: purchaseTransactionLabel.purchaseTransactionDetail },
  ],
  newPurchaseTransactionItems: [
    {
      title: (
        <Link to="/tlo1201">
          {purchaseTransactionLabel.managePurchaseTransaction}
        </Link>
      ),
    },
    { title: purchaseTransactionLabel.newPurchaseTransaction },
  ],
  monthList: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  transactionTypeData: [
    { label: "Purchase", value: "1" },
    { label: "Sale", value: "2" },
  ],
};
